import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import {
  get,
  map,
  pipe,
  groupBy,
  toPairs,
  sortBy,
  filter,
  includes
} from "lodash/fp";

import PriceList from "./PriceList";

const priceGroups = garmentTypes =>
  pipe(
    get("allContentfulGarmentPrice.edges"),
    map("node"),
    sortBy("product.displayOrder"),
    data => {
      if (!garmentTypes) return data;
      return filter(({ product: { slug } }) => includes(slug, garmentTypes))(
        data
      );
    },
    groupBy("product.name"),

    toPairs
  );

const query = graphql`
  {
    allContentfulGarmentPrice(sort: { fields: [price], order: ASC }) {
      edges {
        node {
          id
          price
          garmentName
          product {
            name
            slug
            displayOrder
          }
        }
      }
    }
  }
`;

const PriceListContainer = props => (
  <StaticQuery
    query={query}
    render={data => (
      <PriceList
        priceGroups={priceGroups(props.garmentTypes)(data)}
        {...props}
      />
    )}
  />
);

PriceListContainer.propTypes = {
  garmentTypes: PropTypes.arrayOf(PropTypes.string)
};

PriceListContainer.defaultProps = {
  garmentTypes: null
};

export default PriceListContainer;
